<template>
	<div class="app bg-[transparent]">
		<!-- <p>token：{{ appInfo.token }}</p>
		<p>用户信息：{{ appInfo.userInfo }}</p>
		<p>设备信息：{{ appInfo.deviceInfo }}</p>
		<p>=======================</p> -->
		<RouterView />
		<!-- <h1>{{ $t('common.header') }}</h1>
		<van-button type="primary" size="small" @click="handleLangChange('zh-CN')">中文</van-button
		>&emsp;
		<van-button type="primary" size="small" @click="handleLangChange('en-US')">英文</van-button>
		<br />
		<p>当前语言：{{ lang }}</p>
		<p>=================================================================</p>
		<router-link to="/demo" class="text-lg text-blue-500 text-decoration-underline"
			>测试页面路由</router-link
		> -->
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import appStore from '@/store/appStore'
const kmartHost = (window as any).kmartApp
const { appInfo } = storeToRefs(appStore())
let timer: ReturnType<typeof setTimeout> | null = null // 使用普通变量存储定时器ID
const flag = ref(false) // 导航栏关闭标志
let retryCount = 0 // 重试次数
const MAX_RETRY = 20 // 最大重试次数（20次 * 50ms = 1秒）
let isUnmounted = false // 组件是否已卸载标志

onMounted(() => {
	const host = window.location.host
	// 本地开发环境（localhost、127.0.0.1、或局域网 IP）直接设置测试 token
	if (host.includes('localhost') || host.includes('127.0.0.1') || host.match(/^192\.168\./)) {
		appInfo.value.token =
			'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJLbWFydCBBcGkiLCJpYXQiOjE3NjY2Mjc3MDgsIm5iZiI6MTc2NjYyNzcwOCwiZXhwIjoxNzgyMTc5NzA4LCJzdWIiOjM4LCJqdGkiOiI0NmJmNjExZjcwYTE5NzE5NWE3YjI0YTVlMDgxNWY1NyIsImRhdGEiOnsidXNlcl9pZCI6Mzh9fQ.URouE8dvTG9xltZrROSIv7_Z_6mrWu7tEdKkDSczXCc'
	} else if (kmartHost) {
		// 只有在 App 内才调用原生方法获取用户信息
		setAppInfo()
	}
	// 直接判断 kmartHost 是否存在，而不是依赖异步的 deviceInfo
	if (kmartHost) {
		// 设置是否在app
		appStore().setAppInfo('isApp', true)
		// 设置顶部高度
		appStore().setAppInfo('topHeight', '45')
		// 关闭原生导航（用 try-catch 包裹，防止 SDK 异常导致页面崩溃）
		try {
			closeNav()
		} catch (e) {
			console.error('[App.vue] closeNav error:', e)
		}
	} else {
		appStore().setAppInfo('isApp', false)
	}
})

// 组件卸载时清理定时器，防止内存泄漏
onBeforeUnmount(() => {
	isUnmounted = true
	if (timer !== null) {
		clearTimeout(timer)
		timer = null
	}
})

// 获取app相关信息
const setAppInfo = () => {
	try {
		if (typeof kmartHost?.creds?.get !== 'function') {
			console.warn('[App.vue] kmartHost.creds.get is not a function')
			return
		}
		// 获取用户信息
		kmartHost.creds.get((res: any) => {
			try {
				appInfo.value.token = res?.data?.token || ''
				appInfo.value.userInfo = res?.data?.info || {}
			} catch (e) {
				console.error('[App.vue] creds.get callback error:', e)
			}
		})
	} catch (e) {
		console.error('[App.vue] setAppInfo error:', e)
	}
}
// 关闭导航栏(初始化未能成功关闭，多次调用一下)
const closeNav = () => {
	if (timer !== null) {
		clearTimeout(timer)
		timer = null
	}
	// 组件已卸载、成功或超过最大重试次数则停止
	if (isUnmounted || flag.value || retryCount >= MAX_RETRY) return
	retryCount++
	timer = setTimeout(() => {
		// 再次检查组件是否已卸载
		if (isUnmounted) return
		try {
			if (typeof kmartHost?.appbar?.setVisibility !== 'function') {
				console.warn('[App.vue] kmartHost.appbar.setVisibility is not a function')
				return
			}
			kmartHost.appbar.setVisibility(false, (res: any) => {
				try {
					flag.value = res?.result
				} catch (e) {
					console.error('[App.vue] setVisibility callback error:', e)
				}
			})
			closeNav()
		} catch (e) {
			console.error('[App.vue] closeNav SDK error:', e)
		}
	}, 50)
}
</script>

<style scoped>
.app {
	width: 390px; /* 大写PX不会被postcss转换 */
	min-height: 100vh;
	margin: 0 auto;
}
</style>
